import { createApiClient } from './apiClient';

const api = createApiClient();

// Public API endpoints (no auth required)
export const publicAPI = {
  // Get company information
  getCompanyInfo: () => api.get('/company'),
  
  // Get company stats
  getCompanyStats: () => api.get('/company/stats'),
  
  // Get services
  getServices: () => api.get('/services'),
  
  // Get team members
  getTeamMembers: () => api.get('/team'),
  
  // Get testimonials
  getTestimonials: () => api.get('/testimonials'),
  
  // Get portfolio items
  getPortfolio: () => api.get('/portfolio'),
  
  // Get values
  getValues: () => api.get('/values'),
  
  // Get process steps
  getProcessSteps: () => api.get('/process'),
  
  // Get technologies
  getTechnologies: () => api.get('/technologies'),
  
  // Contact form submission
  submitContact: (data) => api.post('/contact', data)
};

export default publicAPI;